<template>
  <!-- CRM replica of client StepConfirmation.vue (the buyer's completion screen).
       The reservation-email BODY is a branding field, not edited here, so it's not
       part of this preview — only the PDF-attachment indicator is shown. -->
  <div class="step-confirmation">
    <div class="confirmation-icon">&#10003;</div>
    <h2 class="confirmation-title">{{ titleText }}</h2>
    <p class="confirmation-subtitle">{{ subtitleText }}</p>

    <div class="confirmation-info">
      <div class="confirmation-info-row">
        <span class="confirmation-info-icon">&#9993;</span>
        <p>{{ agentReviewText }}</p>
      </div>
    </div>

    <!-- Email the buyer receives — PDF attachment indicator only (the email body is
         branding-owned and not configured here). -->
    <div v-if="sendPdf" class="email-card">
      <div class="email-card__head">
        <span class="email-card__line"><md-icon>mail_outline</md-icon>{{ emailHeading }}</span>
      </div>
      <div class="email-card__attach">
        <span class="email-card__line"><md-icon>picture_as_pdf</md-icon>{{ pdfAttachText }}</span>
      </div>
    </div>

    <div class="confirmation-actions">
      <button class="checkout-btn checkout-btn--primary" :style="{ backgroundColor: brandColor }">{{ viewTripText }}</button>
    </div>
  </div>
</template>

<script>
import previewLang from './previewLang';

export default {
  name: 'ConfirmationPreview',
  mixins: [previewLang],
  props: {
    sendPdf: { type: Boolean, default: false },
    lang: { type: String, default: 'de' },
    brandColor: { type: String, default: '#1a73e8' }
  },
  computed: {
    titleText() { return this.t('checkout_confirmation_title', 'Booking Confirmed!'); },
    subtitleText() { return this.t('checkout_confirmation_subtitle', 'Thank you for your booking request.'); },
    agentReviewText() { return this.t('checkout_confirmation_agent_review', 'Your travel agent has been notified and will contact you with the invoice and payment instructions.'); },
    emailHeading() { return this.t('checkout_preview_email_heading', 'Confirmation email to the buyer'); },
    pdfAttachText() { return this.t('checkout_preview_pdf_attached', 'Reservation-confirmation PDF attached'); },
    viewTripText() { return this.t('checkout_view_trip', 'View Trip'); }
  }
};
</script>

<style scoped>
.step-confirmation { text-align: center; padding: 20px; }
.confirmation-icon {
  width: 64px; height: 64px; border-radius: 50%;
  background: #e8f5e9; color: #2e7d32;
  display: flex; align-items: center; justify-content: center;
  font-size: 28px; font-weight: 700; margin: 0 auto 20px;
}
.confirmation-title { font-size: 24px; font-weight: 700; margin: 0 0 8px; }
.confirmation-subtitle { font-size: 14px; color: #666; margin: 0 auto 28px; max-width: 500px; }

.confirmation-info {
  max-width: 520px; margin: 0 auto 24px; text-align: left;
  background: #f5faff; border: 1px solid #d6e7f7; border-radius: 8px; padding: 14px 18px;
}
.confirmation-info-row { display: flex; align-items: center; justify-content: center; gap: 12px; font-size: 13px; color: #36506b; line-height: 1.5; text-align: center; }
.confirmation-info-row p { margin: 0; }
.confirmation-info-icon { font-size: 18px; flex-shrink: 0; }

.email-card {
  max-width: 520px; margin: 0 auto 24px; text-align: center;
  border: 1px solid #e4e7eb; border-radius: 8px; overflow: hidden; background: #fff;
}
/* Centered via text-align (no flex distribution to fight any global md-icon rules). */
.email-card__head {
  text-align: center; background: #f5f6f8; padding: 10px 16px;
  font-size: 13px; font-weight: 600; color: #4a5159; border-bottom: 1px solid #e8e8e8;
}
.email-card__attach {
  text-align: center; padding: 10px 16px; border-top: 1px dashed #e0e0e0;
  font-size: 12px; color: #36506b; background: #fafbfc;
}
.email-card__line { display: inline-flex; align-items: center; gap: 8px; }
.email-card__head .md-icon { font-size: 18px !important; color: #8a929c !important; margin: 0 !important; }
.email-card__attach .md-icon { font-size: 16px !important; color: #c0392b !important; margin: 0 !important; }

.confirmation-actions { margin-top: 8px; }
.checkout-btn { padding: 10px 28px; border: none; border-radius: 4px; font-size: 14px; font-weight: 600; }
.checkout-btn--primary { color: #fff; }
</style>
